import { initRequest, sendFileToS3 } from './request.js';

const restApi = initRequest(process.env.BACKEND_API);

export async function miniAlbumcreateCustomPhoto({ eventName, fullPath, attendeeUid }) {
  return restApi.post('/event/create-attendee-custom-photo/async', { eventName, fullPath, attendeeUid });
}

export async function customPhotoTmpUploadAccessRetrieve({ eventName, fileName, keepOriginName, attendeeUid, file }) {
  return restApi
    .post('/event/tmp-photo-upload-access/retrieve', {
      event_name: eventName,
      file_name: fileName,
      keep_origin_name: keepOriginName,
      attendee_uid: attendeeUid,
    })
    .then(({ result }) =>
      sendFileToS3(file, {
        s3key: result.fields.key,
        s3bucketUrl: result.url,
        s3fields: result.fields,
        defaultFileType: file.type,
      })
    );
}

export async function uploadFileToAssets({ fileRelativePath, file }) {
  return restApi
    .post(
      '/occo-owner/asset/tmp-upload-access/retrieve',
      {
        file_relative_path: fileRelativePath,
      },
      { addAuth: true }
    )
    .then(({ result }) =>
      sendFileToS3(file, {
        s3key: result.fields.key,
        s3bucketUrl: result.url,
        s3fields: result.fields,
        defaultFileType: file.type,
      })
    );
}
